// src/api/index.js

import client from './internal/httpClient';

// 示例请求函数，你可以根据自己的需求修改和添加
export function ping() {
  return client.get("/ping/index");
}
export const fetchLogs = (data) => {
  return client.post('/logs',data);
};
export const fetchAnalays = () => {
  return client.get('/admin/analysis');
};
export const fetchPosts = () => {
  return client.get('/posts');
};
export const fetchLinks = () => {
  return client.get('/links');
};
export const editLinks = (data) => {
  return client.post('/editlink',data);
};
export const getUser = () => {
  return client.get('/userinfo');
};
export const getActiveAnalysis = () => {
  return client.get('/admin/activeanalysis');
};

// ============ 域名管理 / Cloudflare ============
export const dmList = (status) => client.get('/admin/domainmgr', { action: 'list', status });
export const dmMigrate = (data) => client.post('/admin/domainmgr', { action: 'migrate', ...data });
export const dmBatchMigrate = (data) => client.post('/admin/domainmgr', { action: 'batch_migrate', ...data });
export const dmRefresh = (data) => client.post('/admin/domainmgr', { action: 'refresh', ...data });
export const dmAssign = (data) => client.post('/admin/domainmgr', { action: 'assign', ...data });
export const dmUnassign = (data) => client.post('/admin/domainmgr', { action: 'unassign', ...data });
export const dmRemove = (data) => client.post('/admin/domainmgr', { action: 'remove', ...data });
export const dmHealthCheck = (data) => client.post('/admin/domainmgr', { action: 'health_check', ...data });
export const dmCfVerify = () => client.get('/admin/domainmgr', { action: 'cf_verify' });
export const dmSettingsGet = () => client.get('/admin/domainmgr', { action: 'settings_get' });
export const dmSettingsSave = (data) => client.post('/admin/domainmgr', { action: 'settings_save', ...data });
export const dmSettingsTest = () => client.get('/admin/domainmgr', { action: 'settings_test' });
export const dmTgGet = () => client.get('/admin/domainmgr', { action: 'tg_get' });
export const dmTgSave = (data) => client.post('/admin/domainmgr', { action: 'tg_save', ...data });
export const dmTgValidate = () => client.post('/admin/domainmgr', { action: 'tg_validate' });
export const dmAdminRemindGet = () => client.get('/admin/domainmgr', { action: 'admin_remind_get' });
export const dmAdminRemindSave = (data) => client.post('/admin/domainmgr', { action: 'admin_remind_save', ...data });
export const dmAdminRemindTest = () => client.post('/admin/domainmgr', { action: 'admin_remind_test' });

// ============ 套餐管理 ============
export const planListAll = () => client.post('/plans', { action: 'list_all' });
export const planSave = (plan) => client.post('/plans', { action: 'save', plan });
export const planDelete = (id) => client.post('/plans', { action: 'delete', id });
